import { useEffect, useState } from 'react'

import { MarketingButton } from '@/components/ui/marketing-button'
import { env } from '@/config/env'
import { categories } from './job-categories'

export function JobsSection() {
  const [expanded, setExpanded] = useState(false)

  // Legacy preloaded every static/animated icon up front so the hover gif-swap never flashes.
  useEffect(() => {
    const srcList = categories.map((cat) => cat.image).concat(categories.map((cat) => cat.gif))

    for (const src of srcList) {
      const img = new Image()
      img.src = src
    }
  }, [])

  const visible = expanded ? categories : categories.slice(0, 10)

  return (
    <section className="jobs-section">
      <div className="container">
        <h6>All the jobs that suit you gathered in one place</h6>

        <div className="jobs-section-main">
          {visible.map((job) => (
            <JobIcon key={job.id} text={job.text} image={job.image} gif={job.gif} />
          ))}
        </div>

        <div className="jobs-section-action">
          <button type="button" className="btn-minimal" onClick={() => setExpanded((x) => !x)}>
            {expanded ? '-' : '+'} Show {expanded ? 'less' : 'more'}
          </button>

          {/* Legacy pointed this at the talent app root; preserved (Phase 1). */}
          <MarketingButton href={env.talentAppUrl}>Start hiring now</MarketingButton>
        </div>
      </div>
    </section>
  )
}

// Two stacked <img>s; CSS swaps static PNG for animated GIF on hover (see .job-icon in
// sections.scss). Legacy kept this in its own file only to host the CSSTransition wiring,
// which the plain conditional render above replaces.
function JobIcon({ text, image, gif }: { text: string; image: string; gif: string }) {
  return (
    <div className="job-icon">
      <img className="image" src={image} alt={text} loading="lazy" />
      <img className="gif" src={gif} alt="" loading="lazy" />
      <span>{text}</span>
    </div>
  )
}
